import { createAsyncThunk } from '@reduxjs/toolkit';
import { securedAxiosInstance } from '../../../api/axios';

export const getCheckinPercentage = createAsyncThunk(
  'dashboard/getCheckinPercentage',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/dashboards/checkin`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getPersonal = createAsyncThunk(
  'dashboard/getPersonal',
  async (arg, { rejectWithValue }) => {
    try {
      const response = await securedAxiosInstance.get(`/dashboards/personal`);
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const checkin = createAsyncThunk(
  'dashboard/checkin',
  async ({ id, complete = null, adjustedDue = null }, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      if (complete !== null) {
        formData.append('check_in_occurrence[complete]', complete);
      }
      if (adjustedDue) {
        formData.append('check_in_occurrence[adjusted_due_at]', adjustedDue);
      }
      const response = await securedAxiosInstance.put(
        `/check_in_occurrences/${id}`,
        formData
      );
      return response;
    } catch (error) {
      if (error.response && error.response.data.error) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
